import { render, staticRenderFns } from "./infoHistorias.vue?vue&type=template&id=0cf58fe9&scoped=true&"
import script from "./infoHistorias.vue?vue&type=script&lang=js&"
export * from "./infoHistorias.vue?vue&type=script&lang=js&"
import style0 from "./infoHistorias.vue?vue&type=style&index=0&id=0cf58fe9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf58fe9",
  null
  
)

export default component.exports